// Central data file for easy editing
export const BUSINESS = {
  name: "Agua Flow Mobile",
  tagline: "Saving lives, one lesson at a time.",
  slogan: "swim with flow.",
  shortDescription:
    "Premium mobile aquatic services — swim lessons, private lifeguarding, and water safety education for ages 6 months to adult across Southeast North Carolina.",
  ownerName: "Félix Rivera",
  ownerTitle: "Founder & Lead Swim Coach",
  phone: "787-552-5951",
  phoneHref: "tel:+17875525951",
  email: "aguaflowmobile@gmail.com",
  emailHref: "mailto:aguaflowmobile@gmail.com",
  registrationUrl: "https://aguaflowmobileregistrationform.as.me/",
  serviceAreaShort: "Southeast North Carolina",
  serviceAreas: [
    "Jacksonville",
    "Wilmington",
    "Hampstead",
    "Surf City",
    "Leland",
  ],
  social: {
    instagram: "https://www.instagram.com/aguaflowmobile/",
    facebook: "https://www.facebook.com/p/Agua-Flow-Mobile-61576373191044/",
    instagramHandle: "@aguaflowmobile",
    facebookHandle: "Agua Flow Mobile",
  },
  reviewLink: "https://g.page/r/Cc2KLKZX-l-FEBM/review",
  yearsExperience: "23+",
};

// Real client photos (swap/add more anytime — drop files in /public/photos)
const PHOTO_COACH_CHILD = "/photos/coach-child.jpg";
const PHOTO_COACH_GROUP = "/photos/coach-group.jpg";
const PHOTO_CALM_WATER =
  "https://images.unsplash.com/photo-1468581264429-2548ef9eb732";

export const MISSION = {
  short:
    "Swimming is a life skill that builds confidence, creates independence, and can one day save a life.",
  long:
    "At Agua Flow Mobile, we believe swimming is a life skill that builds confidence, creates independence, and can one day save a life. Our mission is to provide safe, personalized, and engaging swim instruction that meets every swimmer where they are, regardless of age or experience. By bringing professional lessons directly to your home or approved community pool, we make learning convenient, enjoyable, and accessible for busy families. Every lesson is guided by patience, encouragement, and a genuine passion for helping each student grow at their own pace. We don't just teach people how to swim — we help them develop confidence, respect for the water, and skills that will stay with them for a lifetime.",
};

export const STORY = {
  headline: "More Than Swim Lessons — A Lifelong Impact.",
  body:
    "Agua Flow Mobile was founded from a lifelong passion for the water and a vision to elevate the swim lesson experience. Our founder, Félix, began swimming at age three, using the water to overcome his asthma and develop confidence, strength, discipline, and a deep passion for the water. Today, with over 23 years of experience in aquatics, he brings real-world expertise and a personalized approach to every lesson. His coaching has reached families across Puerto Rico, California, New Hampshire, and North Carolina. We are more than a swim service — we are a mission-driven team committed to saving lives and helping families build safety, confidence, and lifelong relationships in the water.",
};

export const SERVICES = [
  {
    id: "premium-mobile",
    name: "Premium Mobile Swim Lessons",
    short: "Private lessons at the comfort of your own pool — 20 or 40 minutes.",
    description:
      "One-on-one instruction in your home or approved community pool. Tailored to age, experience, goals, and comfort — for swimmers from 6 months old through adults.",
    ages: "6 months – Adult",
    sessions: "20 or 40 minutes",
    format: "Private (1-on-1) or small family group (2–4)",
    location: "Your home / community pool",
    skills: [
      "Water safety & survival skills",
      "Submersion and breath control",
      "Float, roll, and recover",
      "Freestyle, backstroke, and stroke development",
      "Confidence and comfort in familiar water",
    ],
    image: "/photos/service-private.jpg",
    tag: "Most popular",
  },
  {
    id: "swim-academy",
    name: "Agua Flow Swim Academy — Group Lessons",
    short: "Small groups of 3–4 at our Jacksonville & Surf City pools.",
    description:
      "A 4-week seasonal program for kids ages 2–13, with one or two 30-minute lessons per week during Spring, Summer, and Fall. Students are grouped by age and skill level for water safety, survival swim, and stroke development.",
    ages: "2 – 13",
    sessions: "30 minutes, up to 2x/week",
    format: "Small group (3–4 students)",
    location: "Jacksonville & Surf City pools",
    skills: [
      "Water safety fundamentals",
      "Survival swim techniques",
      "Stroke development",
      "Group confidence & teamwork",
      "Skill-tested progression",
    ],
    image: "/photos/service-academy.jpg",
    tag: "Seasonal 4-week sessions",
  },
  {
    id: "private-lifeguarding",
    name: "Private Lifeguarding",
    short: "Certified lifeguards for private pool events.",
    description:
      "Our Red Cross-certified lifeguards come to your private pool event with all necessary equipment to keep your guests safe. One lifeguard covers up to 25 swimmers; additional lifeguards may be required for larger events.",
    ages: "All ages",
    sessions: "Event-based",
    format: "On-site at your event",
    location: "Southeast NC",
    skills: [
      "Red Cross Lifeguard certified",
      "CPR & First Aid certified",
      "Full rescue equipment provided",
      "Coverage up to 25 swimmers per guard",
    ],
    image: "/photos/service-lifeguard.jpg",
    tag: "Event ready",
  },
  {
    id: "water-safety",
    name: "Water Safety Education",
    short: "Educational programs for schools, families, and community groups.",
    description:
      "Age-appropriate water safety education tailored to schools, camps, community centers, and family groups — teaching drowning prevention, pool rules, and lifelong water awareness.",
    ages: "All ages",
    sessions: "Custom",
    format: "Group presentation or hands-on",
    location: "Your venue",
    skills: [
      "Drowning prevention basics",
      "Pool & open-water safety",
      "Rescue awareness",
      "Age-appropriate curriculum",
    ],
    image: PHOTO_CALM_WATER,
    tag: "Coming Soon",
    comingSoon: true,
  },
  {
    id: "cpr",
    name: "CPR Certification",
    short: "Certification courses coming soon.",
    description:
      "CPR certification classes are on the way. Join our newsletter to be the first to know when dates are announced.",
    ages: "Adult",
    sessions: "Coming soon",
    format: "In-person",
    location: "Southeast NC",
    skills: ["Adult, child, and infant CPR", "AED usage", "Certification card"],
    image: "https://images.unsplash.com/photo-1468581264429-2548ef9eb732",
    tag: "Coming Soon",
    comingSoon: true,
  },
  {
    id: "first-aid",
    name: "First Aid Certification",
    short: "Certification courses coming soon.",
    description:
      "First Aid certification classes are on the way. Join our newsletter to be the first to know when dates are announced.",
    ages: "Adult",
    sessions: "Coming soon",
    format: "In-person",
    location: "Southeast NC",
    skills: ["Emergency response", "Wound care & injuries", "Certification card"],
    image: "https://images.unsplash.com/photo-1468581264429-2548ef9eb732",
    tag: "Coming Soon",
    comingSoon: true,
  },
];

// Backward compatibility (some pages import PROGRAMS)
export const PROGRAMS = SERVICES.filter((s) =>
  ["premium-mobile", "swim-academy", "private-lifeguarding"].includes(s.id),
);

export const TEAM = [
  {
    name: "Félix Rivera",
    role: "Founder & Lead Swim Coach",
    bio:
      "With 23 years in aquatics as our lead swim coach, Félix has a strong passion for water safety education. He teaches bilingually in both Spanish and English, holds a clinical psychology background, and has experience with ABA therapy and working with students with disabilities. Fun fact: he started swim lessons at age 3, and by age 4 he was crossing a 50-meter pool on his own.",
    certifications: ["CPR & First Aid Instructor", "Red Cross Lifeguard", "Bilingual (EN/ES)"],
    areas: ["Wilmington", "Jacksonville", "Surf City", "Hampstead", "Leland"],
    image: "/photos/felix.jpg",
  },
  {
    name: "Mariela Reyes",
    role: "Social Media & Marketing Coordinator",
    bio: "Mariela loves creating fun and educational water safety content, and she is bilingual in Spanish and English. Fun fact: she is an incredible salsa dancer.",
    certifications: ["Bilingual (EN/ES)", "Content & Outreach"],
    areas: ["Southeast North Carolina"],
    image: "/photos/mariela.jpg",
    imagePosition: "center 25%",
  },
];

export const TESTIMONIALS = [
  {
    name: "Eleni Gibbs",
    role: "Parent",
    location: "Verified Google Review",
    quote:
      "We absolutely love Coach Felix! From day one, he has made Harper feel comfortable and excited about swim lessons — quickly becoming one of Harper's favorite people (we even had to bring him back a prize from vacation).",
    rating: 5,
  },
  {
    name: "Yasemin",
    role: "Parent",
    location: "Verified Google Review",
    quote:
      "My child thrived in the spring swimming lessons, gaining confidence and new skills. Coach Felix is an excellent teacher who is fantastic with the kids. Highly recommend!",
    rating: 5,
  },
  {
    name: "Eduardo Wainberg",
    role: "Adult learner",
    location: "Verified Google Review",
    quote:
      "I had the best time with Agua Flow Mobile. The instructor is brilliant & skillful as well as friendly and supportive! I highly recommend for anyone who is looking for swimming lessons!",
    rating: 5,
  },
  {
    name: "Anna",
    role: "Parent of two",
    location: "Verified Client Review",
    quote:
      "I can't say enough good words about Mr. Felix. He was incredibly patient with my two kids who were so afraid of just getting their face wet. We are so thankful to get our first 6 lessons in and hope to do more and continue to build their confidence in the water.",
    rating: 5,
  },
  {
    name: "Alena",
    role: "Parent",
    location: "Verified Client Review",
    quote:
      "I would recommend them to anyone looking for swim lessons. Coach Felix was great at helping my child stay focused while still having fun during his lessons. He helped my child feel confident in the water and be his best self in the water!",
    rating: 5,
  },
];

// FAQ grouped by category (supports search)
export const FAQ_GROUPS = [
  {
    category: "General Questions",
    items: [
      {
        q: "What services do you offer?",
        a: "We offer Premium Mobile Swim Lessons, the Agua Flow Swim Academy in Jacksonville and Surf City, private lifeguard services, water safety education, and soon community education, CPR, and First Aid programs.",
      },
      {
        q: "Where are you located?",
        a: "We travel to your pool in Wilmington, Leland, Hampstead, and surrounding areas — or you come to ours in Jacksonville and Surf City.",
      },
      {
        q: "What if I don't have a pool?",
        a: "Contact us — we may have access to a partner pool near you.",
      },
      {
        q: "When do I pay?",
        a: "When you're ready to register, payment is required in advance as part of the registration process.",
      },
    ],
  },
  {
    category: "Swim Lessons",
    items: [
      {
        q: "What age can I start swim lessons?",
        a: "We teach swimmers from 6 months old through adults.",
      },
      {
        q: "How are lessons customized?",
        a: "Every lesson is tailored to the swimmer's age, experience, goals, and comfort level.",
      },
      {
        q: "How many lessons will I or my child need to learn how to swim?",
        a: "Progress varies. However, we've seen students committed to our program learn how to swim in 1–3 months of classes.",
      },
      {
        q: "Do you offer groups?",
        a: "Yes! For siblings, best friends, or family members we offer 2–4 students in the same class — small groups with similar skill, experience, and age.",
      },
      {
        q: "What if my child cries?",
        a: "Completely normal — it can be a defense mechanism from attachment with the parent, fear of trying something new, or fear of a new person and environment. At Agua Flow Mobile we don't measure results by tears or smiles — we measure them by learning the skills. Our lessons are fun, safe, and challenging, and our swim coaches are trained to work with all kinds of students, with or without prior trauma, using patience and creativity. The most important thing is for parents not to give up and to keep coming back so the child can build a sense of habit and muscle memory.",
      },
      {
        q: "What if my child gets out of the pool?",
        a: "Parents simply guide the child back to the lesson. Staying consistent helps children build confidence and resilience.",
      },
      {
        q: "Are your swim instructors certified?",
        a: "Every swim instructor is CPR and First Aid certified, passes a background check, and is trained to use the Flow Method.",
      },
      {
        q: "Do you teach swimmers with disabilities?",
        a: "Yes — we welcome swimmers of all abilities and personalize each lesson to meet their individual needs.",
      },
    ],
  },
  {
    category: "Lifeguard Services",
    items: [
      {
        q: "How do lifeguard services work?",
        a: "Our certified lifeguards come to your private pool event with all the necessary equipment to keep your guests safe.",
      },
      {
        q: "How many swimmers are included?",
        a: "One lifeguard covers up to 25 swimmers. Additional lifeguards may be required for larger events.",
      },
      {
        q: "Are your lifeguards certified?",
        a: "Yes — all lifeguards are Red Cross certified in Lifeguarding, CPR, and First Aid.",
      },
    ],
  },
  {
    category: "Agua Flow Swim Academy",
    items: [
      {
        q: "What are the Agua Flow Swim Academy Group Lessons?",
        a: "A four-week swim program with one or two lessons per week during Spring, Summer, and Fall for kids ages 2–13 learning water safety skills, survival swim skills, and stroke development. Each group practices 30 minutes with a total of 3–4 students per group.",
      },
      {
        q: "How are groups organized?",
        a: "Students are grouped by age and skill level to create a fun and effective learning environment.",
      },
      {
        q: "How long are the lessons?",
        a: "30 minutes each.",
      },
      {
        q: "How long is the program?",
        a: "4 weeks, with a total of 4 to 8 lessons across the program.",
      },
      {
        q: "How do I register?",
        a: "Registration is completed online, and full payment reserves your child's spot.",
      },
      {
        q: "Are there any make-up classes?",
        a: "Due to our tight schedule we don't offer make-ups for personal reasons. Weather cancellations or classes canceled by the swim coach will be rescheduled with make-up lessons.",
      },
    ],
  },
];

// Flattened FAQ for backward compat and the FAQ page search
export const FAQ = FAQ_GROUPS.flatMap((g) =>
  g.items.map((i) => ({ ...i, category: g.category })),
);

export const HOW_IT_WORKS = [
  {
    step: "01",
    title: "Inquiry",
    description:
      "Fill out our short contact form or give us a call. Tell us your child's age, any prior swim experience, and your goals.",
  },
  {
    step: "02",
    title: "Consultation",
    description:
      "We'll have a quick conversation to recommend the right program, discuss pricing, and answer your questions.",
  },
  {
    step: "03",
    title: "Register & Schedule",
    description:
      "Full payment reserves your spot. We confirm dates, times, and location — at your pool or ours.",
  },
  {
    step: "04",
    title: "Lessons Begin",
    description:
      "Your swimmer starts learning water safety and swim skills in a warm, encouraging environment — guided by a veteran coach.",
  },
];

export const TRUST_RIBBON = [
  "23+ Years of Aquatic Education",
  "CPR & First Aid Certified Instructor",
  "Red Cross Lifeguard Certified",
  "Ages 6 Months to Adult",
  "Mobile, Academy & Lifeguard Programs",
  "Saving Lives, One Lesson at a Time",
];

export const WHY_CHOOSE = [
  {
    title: "Lessons come to you.",
    body: "Premium mobile swim lessons taught at your home or approved community pool — no schlepping, no crowded facilities.",
    icon: "home",
  },
  {
    title: "23+ years of aquatic expertise.",
    body: "Coach Félix has taught families across Puerto Rico, California, New Hampshire, and North Carolina — with certifications to back it up.",
    icon: "award",
  },
  {
    title: "The Flow Method.",
    body: "A patient, personalized approach measured by real skills learned — not tears or smiles.",
    icon: "waves",
  },
  {
    title: "Safety, always.",
    body: "Every instructor is CPR & First Aid certified, background-checked, and trained to teach swimmers of all abilities.",
    icon: "shield",
  },
];

export const POLICIES = [
  {
    section: "1.0 — Safety & Conduct",
    items: [
      {
        title: "Assumption of Risk & Release of Liability",
        body: "Participation involves inherent risks including drowning, injury, and other water-related hazards. By signing up, you voluntarily assume all risks and release Agua Flow Mobile from liability except in cases of gross negligence or misconduct.",
      },
      {
        title: "1.1 Participant Conduct",
        body: "Follow all rules, facility regulations, and instructor guidelines. Disruptive or unsafe behavior after 3 warnings may result in dismissal from the program without refund.",
      },
      {
        title: "1.2 Photo & Video Consent",
        body: "Photos and videos may be used for promotional and educational purposes. Notify us before your first lesson if you do not consent.",
      },
    ],
  },
  {
    section: "2.0 — Lesson & Program Policies",
    items: [
      {
        title: "Cancellation Policy",
        body: "Cancel at least 24 hours in advance to reschedule or receive a lesson credit. Late cancellations or no-shows may result in forfeiture of the lesson. Instructor-initiated cancellations will be rescheduled or credited.",
      },
      {
        title: "2.1 Weather & Pool Conditions",
        body: "Lessons and lifeguard services may be postponed or canceled due to weather or pool conditions.",
      },
      {
        title: "2.2 Lifeguard Services — Thunderstorms",
        body: "During a thunderstorm, lifeguards will clear and close the pool. A 15-minute wait period will be observed before reopening.",
      },
      {
        title: "2.3 Swim Academy Schedule",
        body: "Agua Flow Swim Academy follows a fixed schedule with no make-up lessons unless canceled and initiated by the swim coach.",
      },
      {
        title: "2.4 Payments",
        body: "Full payment is required at least 3 days before the first lesson. Late payments may incur additional fees. We accept PayPal and credit/debit card.",
      },
    ],
  },
  {
    section: "3.0 — Packages & Refunds",
    items: [
      {
        title: "3.1 Small Group Lessons",
        body: "2–4 participants form the group. 20- or 40-minute lessons only. Participants must be of similar age and swim ability.",
      },
      {
        title: "3.2 Refund Policy",
        body: "A full refund may be requested after the first lesson if you are not satisfied. Requests must be made via email. Refunds for unused lessons due to missed or late cancellations are non-refundable.",
      },
      {
        title: "3.3 Lesson Packages",
        body: "Non-transferable and for the registered participant only. Cannot be shared or divided. Unused lessons due to missed or late cancellations are non-refundable.",
      },
      {
        title: "3.4 Travel Zone",
        body: "Premium Mobile Swim Lessons are provided in Wilmington, Leland, Hampstead, and surrounding areas. Additional fees may apply outside this area.",
      },
    ],
  },
  {
    section: "4.0 — Additional Policies",
    items: [
      {
        title: "4.1 No-Show Policy",
        body: "Without cancellation notice, the lesson will be marked as completed and deducted from your package. If the participant does not arrive within 15 minutes, the lesson is automatically canceled.",
      },
      {
        title: "4.2 Lateness Policy",
        body: "Lessons begin at the scheduled time. Instructors wait up to 10 minutes for late arrivals. Time missed due to lateness cannot be made up or rescheduled.",
      },
      {
        title: "4.3 Equipment",
        body: "Participants must bring appropriate swimwear, towel, swim diaper (if applicable), and goggles. Agua Flow Mobile provides all instructional equipment.",
      },
      {
        title: "4.4 Parent & Young Participants",
        body: "Participants 16 years of age and under must be accompanied by a supervising adult (18+).",
      },
      {
        title: "4.5 Lost Items",
        body: "Agua Flow Mobile is not responsible for lost, stolen, or misplaced items.",
      },
    ],
  },
];

export const IMAGES = {
  hero: PHOTO_COACH_CHILD,
  founder: "/photos/about-group.jpg",
  programMobile: "/photos/service-private.jpg",
  programAcademy: "/photos/service-academy.jpg",
  pool: PHOTO_CALM_WATER,
  water: PHOTO_CALM_WATER,
};
